export default [
  { label: 'About Me', url: '/' },
  { label: 'Work History', url: '/work-history' },
  { label: 'Music', url: '/music' },
  { label: 'Open Source', url: '/open-source' },
  { label: 'Games', url: '/games' },
  { label: 'Videos', url: '/videos' },
  { label: 'Blog', url: 'https://blog.benwiley.org' },
  { label: 'Contact', url: '/contact' },
]
